import { render, staticRenderFns } from "./socials-modal.vue?vue&type=template&id=2ae2f49c&scoped=true&"
import script from "./socials-modal.vue?vue&type=script&lang=js&"
export * from "./socials-modal.vue?vue&type=script&lang=js&"
import style0 from "./socials-modal.vue?vue&type=style&index=0&id=2ae2f49c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae2f49c",
  null
  
)

export default component.exports